import { db } from '../client/index';
import { collection, getDocs, doc, getDoc, addDoc, updateDoc, deleteDoc } from 'firebase/firestore/lite';

const categoriesCollection = collection(db, 'categories');

export const getCategories = async () => {
  try {
    const categoriesSnapshot = (await getDocs(categoriesCollection)).docs;
    const categoriesItems = categoriesSnapshot.map(category => ({ id: category.ref.id, ...category.data() }));
    return categoriesItems;
  } catch (err) {
    return err;
  }
}

export const getCategory = async (id) => {
  try {
    const categorySnapshot = doc(db, 'categories', id);
    const categoryItem = getDoc(categorySnapshot);
    return (await categoryItem).exists() ? (await categoryItem).data() : null;
  } catch (err) {
    return err;
  }
}

export const createCategory = async (category) => {
  try {
    const { id } = await addDoc(categoriesCollection, category);
    const categoryAdded = { id, ...category };
    return categoryAdded;
  } catch (err) {
    return err;
  }
}

export const updateCategory = async (id, category) => {
  try {
    const categoryRef = doc(db, 'categories', id);
    await updateDoc(categoryRef, category);
    return { id, ...category };
  } catch (err) {
    return err;
  }
}

export const deleteCategory = async (id) => {
  try {
    const categoryRef = doc(db, 'categories', id);
    await deleteDoc(categoryRef);
    return id;
  } catch (err) {
    return err;
  }
}